module.exports = __webpack_public_path__ + "img/DE00678.d37ed168.png";